import { useEffect, useState } from 'react';
import api from '~/services/api';

/**
 * Busca as tabelas de domínio (Gênero, Raça/Cor, Nacionalidade, Estado) que alimentam os selects
 * do Cadastro de Funcionários. Nenhuma dessas opções fica hardcoded no frontend — isolado aqui
 * para ser o único lugar a tocar caso os endpoints mudem.
 */
function usePlainOptions(url, formatLabel = item => item.nome) {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;

    api
      .get(url)
      .then(response => {
        if (!active) return;
        const list = Array.isArray(response?.data) ? response.data : [];
        setOptions(list.map(item => ({ value: String(item.id), label: formatLabel(item) })));
      })
      .catch(() => active && setOptions([]))
      .finally(() => active && setLoading(false));

    return () => {
      active = false;
    };
  }, [url]);

  return { options, loading };
}

function useDominioOptions() {
  const genero = usePlainOptions('/signed/geral/generos');
  const racaCor = usePlainOptions('/signed/geral/racascor');
  const nacionalidade = usePlainOptions('/signed/geral/nacionalidades');
  const estado = usePlainOptions('/signed/geral/estados', item => `${item.nome} (${item.uf})`);

  return {
    generoOptions: genero.options,
    racaCorOptions: racaCor.options,
    nacionalidadeOptions: nacionalidade.options,
    estadoOptions: estado.options,
    loadingDominios: genero.loading || racaCor.loading || nacionalidade.loading || estado.loading,
  };
}

export default useDominioOptions;
